"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../schema");
const value = schema_1.Schema.number()
    .expiration(31536000)
    .unit("mmol/L")
    .precision(2)
    .min(0)
    .max(999)
    .interpretation({ vocab: "ktx", code: "lab_LDL_cholesterol" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value });
